/* eslint-disable react/prop-types */
import React from 'react';
import { Tabs, Input, Typography } from 'antd';
import ProductionJoints from '../components/DSR/ProductionJoints';
import DownTime from '../components/DSR/DownTime';
import EquipmentUsage from '../components/DSR/EquipmentUsage';
import EhsIssuesAndCorrectiveActions from '../components/DSR/EhsIssuesAndCorrectiveActions';
import ConumablesAndPpeUsage from '../components/DSR/ConumablesAndPpeUsage';
import TechnicianLog from '../components/DSR/TechnicianLog';
import DsrMaterialConsumption from '../components/DSR/DsrMaterialConsumption';
import ToolBox from '../components/DSR/ToolBox';
import { connect } from 'react-redux';
import { get } from 'lodash';

const { TabPane } = Tabs;

const DSRTabList = (props) => {
  const {
    selectedProject,
    selectedData,
    isFetchingDsrMaterialConsumption,
    dsrMaterialConsumption,
    dsrSowId,
    productionJointsList,
  } = props;

  const { Text } = Typography;

  const commentsBar = (dayDsrShiftTitle, nightDsrShiftTitle, dayDsrShiftComment, nightDsrShift) => {
    return (
      <div className="modern-dsr-modal-comments-row">
        <div className="modern-dsr-modal-comment-field">
          <Text className="modern-dsr-modal-label">{dayDsrShiftTitle}</Text>
          <Input.TextArea
            rows={2}
            value={dayDsrShiftComment}
            className="modern-dsr-modal-textarea"
            readOnly
          />
        </div>
        <div className="modern-dsr-modal-comment-field">
          <Text className="modern-dsr-modal-label">{nightDsrShiftTitle}</Text>
          <Input.TextArea
            rows={2}
            value={nightDsrShift}
            className="modern-dsr-modal-textarea"
            readOnly
          />
        </div>
      </div>
    );
  };

  const shiftCommentsPair = (dayTitle, nightTitle, dayValue, nightValue) => (
    <div className="modern-dsr-modal-comments-row">
      <div className="modern-dsr-modal-comment-field">
        <Text className="modern-dsr-modal-label">{dayTitle}</Text>
        <Input.TextArea rows={2} value={dayValue} className="modern-dsr-modal-textarea" readOnly />
      </div>
      <div className="modern-dsr-modal-comment-field">
        <Text className="modern-dsr-modal-label">{nightTitle}</Text>
        <Input.TextArea rows={2} value={nightValue} className="modern-dsr-modal-textarea" readOnly />
      </div>
    </div>
  );

  return (
    <div className="modern-dsr-modal-detail-root">
      {selectedData.isSkipped != 1 ? (
        <Tabs className="modern-dsr-modal-tabs h-100" defaultActiveKey="1">
          <TabPane tab="Material Consumption" key="1" style={{ position: 'relative' }}>
            <DsrMaterialConsumption
              selectedProject={selectedProject}
              selectedData={selectedData}
              dsrSowId={dsrSowId}
            />
            {shiftCommentsPair(
              'Material Day Shift Comments',
              'Material Night Shift Comments',
              dsrMaterialConsumption[0]?.dlmDayShiftComments,
              dsrMaterialConsumption[0]?.dlmNightShiftComments,
            )}
            {commentsBar(
              'DSR Day Shift Comments',
              'DSR Night Shift Comments',
              selectedData?.dsrDayShiftComments,
              selectedData?.dsrNightShiftComments,
            )}
          </TabPane>
          <TabPane tab="Production joints" key="2" style={{ position: 'relative' }}>
            <ProductionJoints
              selectedProject={selectedProject}
              selectedData={selectedData}
              dsrSowId={dsrSowId}
            />
            {shiftCommentsPair(
              'Production joints Day Shift Comments',
              'Production joints Night Shift Comments',
              productionJointsList[0]?.dayShiftComments,
              productionJointsList[0]?.nightShiftComments,
            )}
            {commentsBar(
              'DSR Day Shift Comments',
              'DSR Night Shift Comments',
              selectedData?.dsrDayShiftComments,
              selectedData?.dsrNightShiftComments,
            )}
          </TabPane>
          <TabPane tab="Equipment usage" key="3" style={{ position: 'relative' }}>
            <EquipmentUsage
              selectedProject={selectedProject}
              selectedData={selectedData}
              dsrSowId={dsrSowId}
            />
            {commentsBar(
              'DSR Day Shift Comments',
              'DSR Night Shift Comments',
              selectedData?.dsrDayShiftComments,
              selectedData?.dsrNightShiftComments,
            )}
          </TabPane>
          <TabPane tab="EHS Issues & Corrective Actions" key="4" style={{ position: 'relative' }}>
            <EhsIssuesAndCorrectiveActions
              selectedProject={selectedProject}
              selectedData={selectedData}
              dsrSowId={dsrSowId}
            />
            {commentsBar(
              'DSR Day Shift Comments',
              'DSR Night Shift Comments',
              selectedData?.dsrDayShiftComments,
              selectedData?.dsrNightShiftComments,
            )}
          </TabPane>
          <TabPane tab="Down time" key="5" style={{ position: 'relative' }}>
            <DownTime selectedProject={selectedProject} selectedData={selectedData} dsrSowId={dsrSowId} />
            {commentsBar(
              'DSR Day Shift Comments',
              'DSR Night Shift Comments',
              selectedData?.dsrDayShiftComments,
              selectedData?.dsrNightShiftComments,
            )}
          </TabPane>
          <TabPane tab="Consumables & PPE Usage" key="6" style={{ position: 'relative' }}>
            <ConumablesAndPpeUsage
              selectedProject={selectedProject}
              selectedData={selectedData}
              dsrSowId={dsrSowId}
            />
            {commentsBar(
              'DSR Day Shift Comments',
              'DSR Night Shift Comments',
              selectedData?.dsrDayShiftComments,
              selectedData?.dsrNightShiftComments,
            )}
          </TabPane>
          <TabPane tab="Technician Log" key="7" style={{ position: 'relative' }}>
            <TechnicianLog selectedProject={selectedProject} selectedData={selectedData} dsrSowId={dsrSowId} />
            {commentsBar(
              'DSR Day Shift Comments',
              'DSR Night Shift Comments',
              selectedData?.dsrDayShiftComments,
              selectedData?.dsrNightShiftComments,
            )}
          </TabPane>
          <TabPane tab="ToolBox" key="8" style={{ position: 'relative' }}>
            <ToolBox selectedProject={selectedProject} selectedData={selectedData} dsrSowId={dsrSowId} />
            {commentsBar(
              'DSR Day Shift Comments',
              'DSR Night Shift Comments',
              selectedData?.dsrDayShiftComments,
              selectedData?.dsrNightShiftComments,
            )}
          </TabPane>
        </Tabs>
      ) : (
        <div className="modern-dsr-modal-skipped-wrap">
          <Text className="modern-dsr-modal-skipped-title">DSR Skipped</Text>
        </div>
      )}
      <div className="modern-dsr-modal-signatures">
        {selectedData.managerSignatureS3Object && selectedData.managerSignatureS3Object.objectUrl && (
          <div style={{ flex: '1 1 200px', minWidth: 0 }}>
            <Text className="modern-dsr-modal-label">Manager Signature</Text>
            <img
              src={selectedData.managerSignatureS3Object.objectUrl}
              alt="manager signature"
              style={{ width: '100%', maxWidth: 280, height: 'auto', maxHeight: 100, objectFit: 'contain' }}
            />
          </div>
        )}
        {selectedData.clientSignatureS3Object && selectedData.clientSignatureS3Object.objectUrl && (
          <div style={{ flex: '1 1 200px', minWidth: 0 }}>
            <Text className="modern-dsr-modal-label">Client Signature</Text>
            <img
              src={selectedData.clientSignatureS3Object.objectUrl}
              alt="client signature"
              style={{ width: '100%', maxWidth: 280, height: 'auto', maxHeight: 100, objectFit: 'contain' }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ materialConsumptionReducer, productionJointsReducer }) => {
  const dsrMaterialConsumption = get(materialConsumptionReducer, 'dsrMaterialConsumption', []);
  const productionJointsList = get(productionJointsReducer, 'productionJointsList', []);
  const isFetchingDsrMaterialConsumption = get(
    materialConsumptionReducer,
    'isFetchingDsrMaterialConsumption',
    false,
  );

  return {
    dsrMaterialConsumption,
    isFetchingDsrMaterialConsumption,
    productionJointsList,
  };
};

export default connect(mapStateToProps, null)(DSRTabList);
